<template>
  <div class="cpn-roading">
    <img src="../assets/img/loading.png" alt="">
  </div>
</template>

<script>
export default {
};
</script>

<style lang="less" scoped>
.cpn-roading {
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: rgba(255,255,255,.7);
  z-index: 1200;
  text-align: center;
  vertical-align: middle;
  img {
    -webkit-animation: app-loading 1s infinite;
    width: 55px;
    height: auto;
    position: absolute;
    left: calc(50% - 33px);
    top: calc(50% - 100px);
    z-index: 1500;
  }
  @-webkit-keyframes app-loading {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(45deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
}
</style>
